import { apiToken, baseApiUrl } from 'embed/constants/config'
import { buildUrl } from 'ui/multi-product/utils'
import { fetch } from 'whatwg-fetch'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ApiResponse<T = any> extends Response {
  data: T
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiPromise<T = any> = Promise<ApiResponse<T>>

export class Api {
  static readonly DEFAULT_HEADERS = {
    Accept: 'application/vnd.evenfinancial.v1+json',
    Authorization: `Bearer ${apiToken}`,
  }

  private static async parseJSON(res: Response) {
    const text = await res.text()
    try {
      return JSON.parse(text)
    } catch (err) {
      return {}
    }
  }

  public get(url: string, params = {}): ApiPromise {
    const absoluteUrl = buildUrl(new URL(url, baseApiUrl).href, params)
    return fetch(absoluteUrl.href, {
      headers: { ...Api.DEFAULT_HEADERS },
      method: 'GET',
    }).then(async (res) => ({
      ...res,
      data: await Api.parseJSON(res),
      headers: res.headers,
      status: res.status,
      statusText: res.statusText,
    }))
  }

  public patch(url: string, data?: object): ApiPromise {
    const absoluteUrl = new URL(url, baseApiUrl)
    return fetch(absoluteUrl.href, {
      body: JSON.stringify(data),
      headers: {
        ...Api.DEFAULT_HEADERS,
        Accept: 'application/json',
        'Content-type': 'application/json;charset=UTF-8',
      },
      method: 'PATCH',
    }).then(async (res) => Api.parseJSON(res))
  }

  public post<T = object>(url: string, data?: T): ApiPromise {
    const absoluteUrl = new URL(url, baseApiUrl)
    return fetch(absoluteUrl.href, {
      body: JSON.stringify(data),
      headers: {
        ...Api.DEFAULT_HEADERS,
        Accept: 'application/json',
        'Content-type': 'application/json;charset=UTF-8',
      },
      method: 'POST',
    }).then(async (res) => ({ ...res, data: await Api.parseJSON(res) }))
  }
}

export default new Api()
